import { useState } from "react";
import { FaCode } from "react-icons/fa";

const FlagIcon = ({ flag }) => {
  const [showPopover, setShowPopover] = useState(false);

  return (
    <span
      className="relative inline-block cursor-pointer"
      onMouseEnter={() => setShowPopover(true)}
      onMouseLeave={() => setShowPopover(false)}
    >
      <FaCode className="text-yellow-500 inline-block" />
      {showPopover && (
        <div className="absolute z-10 px-2 py-1 text-sm text-white bg-gray-900/90 rounded-lg shadow-lg bottom-full left-1/2 transform -translate-x-1/2 mb-1">
          &lt;&lt;{flag}&gt;&gt;
        </div>
      )}
    </span>
  );
};

export default FlagIcon;
